var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7903_98968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8951 0H3.1089C1.47172 0 0.144531 1.32719 0.144531 2.96437V20.7506C0.144531 22.3878 1.47172 23.715 3.1089 23.715H20.8951C22.5323 23.715 23.8595 22.3878 23.8595 20.7506V2.96437C23.8595 1.32719 22.5323 0 20.8951 0Z",
    fill: "#64A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8349 4.36313L3.79272 10.5507C2.69781 10.9899 2.70431 11.6006 3.59315 11.873L7.59413 13.1217L9.125 17.8153C9.31111 18.329 9.21936 18.5327 9.75881 18.5327C10.1751 18.5327 10.3598 18.3429 10.5916 18.1164C10.7391 17.9721 11.6145 17.121 12.592 16.1706L16.7538 19.2455C17.5196 19.668 18.0726 19.4491 18.2633 18.5343L20.9951 5.66059C21.2748 4.53923 20.5676 4.03059 19.8349 4.36313ZM8.22204 12.8348L17.2403 7.14517C17.6905 6.87214 18.1033 7.01893 17.7643 7.31978L10.0424 14.2869L9.74171 17.4938L8.22204 12.8348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7903_98968"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.144531,
    width: 23.715,
    height: 23.715,
    rx: 4.08879,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a7a2473a62f73fc0e8854698d142d269.svg";
export { ForwardRef as ReactComponent };